import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'questionText',
    'answerText',
    'addButton',
    'rowTemplate',
    'cellTemplate',
    'actionCellTemplate'
  ];

  static values = {
    editableClassList: { type: Array, default: [
      'px-4',
      'py-2',
      'border',
      'border-gray-300',
      'focus:outline-none',
      'hover:bg-gray-50'
    ]}
  }

  updateAddButtonVisibility() {
    if (this.questionTextTarget.value != '' && this.answerTextTarget.value != '') {
      this.addButtonTarget.disabled = false;
    } else {
      this.addButtonTarget.disabled = true;
    }
  }

  addQuestion() {
    const table = this.element.querySelector('#quiz-questions-table');
    const rowSection = table.querySelector('.rows-section');
    const row = this.rowTemplateTarget.cloneNode(true).content.children[0];

    const questionCell = this.cellTemplateTarget.cloneNode(true).content.children[0];
    questionCell.classList.add('quiz-question-cell');

    const answerCell = this.cellTemplateTarget.cloneNode(true).content.children[0];
    answerCell.classList.add('quiz-answer-cell');

    const actionCell = this.actionCellTemplateTarget.cloneNode(true).content.children[0];

    questionCell.textContent = this.questionTextTarget.value;
    answerCell.textContent = this.answerTextTarget.value;

    this._appendHiddenInputs(actionCell, questionCell, answerCell);

    row.appendChild(questionCell);
    row.appendChild(answerCell);
    row.appendChild(actionCell);
    rowSection.appendChild(row);

    this._clearInputTargets();
  }

  editQuestion(event) {
    const actionsContainer = event.target.closest('.quiz-question-actions');
    const rowContainer = actionsContainer.closest('.table-body-row');

    this._toggleEditableCell(rowContainer, true);
    this._toggleIcons(actionsContainer, true);
  }

  confirmEditing(event) {
    const actionsContainer = event.target.closest('.quiz-question-actions');
    const rowContainer = actionsContainer.closest('.table-body-row');
    const newQuestion = rowContainer.querySelector('.quiz-question-cell').textContent;
    const newAnswer = rowContainer.querySelector('.quiz-answer-cell').textContent;

    this._toggleEditableCell(rowContainer, false);
    this._toggleIcons(actionsContainer, false);
    this._saveNewValues(rowContainer, newQuestion, newAnswer);
  }

  cancelEditing(event) {
    const actionsContainer = event.target.closest('.quiz-question-actions');
    const rowContainer = actionsContainer.closest('.table-body-row');

    this._toggleEditableCell(rowContainer, false);
    this._toggleIcons(actionsContainer, false);
    this._rollbackChanges(rowContainer);
  }

  deleteQuestion(event) {
    const actionsContainer = event.target.closest('.quiz-question-actions');
    const rowContainer = actionsContainer.closest('.table-body-row');

    rowContainer.remove();
    this._resetInputs();
  }

  _appendHiddenInputs(actionContainer, questionCell, answerCell) {
    const position = this._calculateNextPosition();

    const questionInput = document.createElement('input');
    questionInput.type = 'hidden';
    questionInput.classList.add('quiz-question-input');
    questionInput.name = `ai_assistant[metadata][conversation_items][${position}][question]`;
    questionInput.value = questionCell.textContent;

    const answerInput = document.createElement('input');
    answerInput.type = 'hidden';
    answerInput.classList.add('quiz-answer-input');
    answerInput.name = `ai_assistant[metadata][conversation_items][${position}][answer]`;
    answerInput.value = answerCell.textContent;

    actionContainer.appendChild(questionInput);
    actionContainer.appendChild(answerInput);
  }

  _calculateNextPosition() {
    const rows = this.element.querySelectorAll('.table-body-row');
    return rows.length;
  }

  _clearInputTargets() {
    this.questionTextTarget.value = '';
    this.answerTextTarget.value = '';
    this.addButtonTarget.disabled = true;
  }

  _toggleEditableCell(container, isEditable) {
    const questionCell = container.querySelector('.quiz-question-cell');
    const answerCell = container.querySelector('.quiz-answer-cell');

    questionCell.setAttribute('contenteditable', isEditable);
    answerCell.setAttribute('contenteditable', isEditable);

    this.editableClassListValue.forEach((className) => {
      questionCell.classList.toggle(className, isEditable);
      answerCell.classList.toggle(className, isEditable);
    });
  }

  _toggleIcons(container, isEditable) {
    const checkIcon = container.querySelector('.check-button');
    const cancelIcon = container.querySelector('.cancel-button');
    const editIcon = container.querySelector('.edit-button');
    const trashIcon = container.querySelector('.trash-button');

    checkIcon.classList.toggle('hidden', !isEditable);
    cancelIcon.classList.toggle('hidden', !isEditable);
    editIcon.classList.toggle('hidden', isEditable);
    trashIcon.classList.toggle('hidden', isEditable);
  }

  _saveNewValues(container, newQuestion, newAnswer) {
    const questionInput = container.querySelector('.quiz-question-input');
    const answerInput = container.querySelector('.quiz-answer-input');

    questionInput.value = newQuestion.trim();
    answerInput.value = newAnswer.trim();
  }

  _rollbackChanges(rowContainer) {
    const questionCell = rowContainer.querySelector('.quiz-question-cell');
    const answerCell = rowContainer.querySelector('.quiz-answer-cell');

    const questionInput = rowContainer.querySelector('.quiz-question-input');
    const answerInput = rowContainer.querySelector('.quiz-answer-input');

    questionCell.textContent = questionInput.value;
    answerCell.textContent = answerInput.value;
  }

  _resetInputs() {
    const table = this.element.querySelector('#quiz-questions-table');
    const rows = table.querySelectorAll('.table-body-row');
    let position = 0;

    rows.forEach((row) => {
      const questionInput = row.querySelector('.quiz-question-input');
      const answerInput = row.querySelector('.quiz-answer-input');

      questionInput.name = `ai_assistant[metadata][conversation_items][${position}][question]`;
      answerInput.name = `ai_assistant[metadata][conversation_items][${position}][answer]`;
      position++;
    });
  }
}
